import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { ElementType, FC } from "react";
import {
    Academy,
    AlleZaehlerstaende,
    Anlagenmanagement,
    ArrowBottomLeft,
    ArrowBottomRight,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowTopLeft,
    ArrowUp,
    Attachment,
    AttowTopRight,
    Autarky,
    Calendar,
    CalendarAdd,
    CardsView,
    CartCheckout,
    Cascade,
    ChargeFlash,
    ChargeFull,
    ChargePlug,
    Check,
    Checkbox,
    CheckFilled,
    Checkmark,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleClose,
    Close,
    CloseFilled,
    CloseSmall,
    Cockpit,
    Download,
    Duplicate,
    Edit,
    Edit2,
    EkpDownload,
    Email,
    Favorite,
    FavoriteFilled,
    File,
    FileDownload,
    FileView,
    Filter,
    FilterHor,
    FlowerView,
    Help,
    Home,
    Info,
    Infocenter,
    InfocenterLink,
    InfoFilled,
    Label,
    LabelFilled,
    Link,
    List,
    Livedaten,
    Lock,
    Logout,
    MapView,
    Megaphone as MegaphoneSvg,
    Menu,
    Minimize,
    Minus,
    MinusCircle,
    Modify,
    Monitor,
    MoreHor,
    Move,
    Navigate,
    News,
    NoneMobileView,
    Notification,
    OfferCustomization,
    OpenInNew,
    PeakShaving,
    Phone,
    PickupTruck,
    PlayFilled,
    Plus,
    QrCode,
    RadioButtonOff,
    RadioButtonOn,
    RadioOff,
    RadioOn,
    Ratio,
    Reclamation,
    Refresh,
    Reload,
    Rollout,
    Routeplanner,
    Schnelleinstieg,
    Search,
    Shop,
    Skip,
    Star,
    StarActive,
    StatusInactive,
    Sunny,
    Trash,
    TurnOff,
    User,
    UserList,
    UserRemove,
    VisibilityOff,
    VisibilityOn,
    Waermepumpensteuerung,
    Wallbox,
    WarningFilled,
    WarningHard,
    WarningHardFilled,
    WiFi,
    WiFiOff,
    XCircle,
    ZaehlerstandInput,
    Internet,
    Upload,
} from "src/generated/icons";

const iconFor =
    (svgComponent: ElementType): FC<SvgIconProps> =>
    (props) => <SvgIcon role="img" {...props} component={svgComponent} />;

export const AcademyIcon = iconFor(Academy);
export const AlleZaehlerstaendeIcon = iconFor(AlleZaehlerstaende);
export const AnlagenManagementIcon = iconFor(Anlagenmanagement);
export const ArrowBottomLeftIcon = iconFor(ArrowBottomLeft);
export const ArrowBottomRightIcon = iconFor(ArrowBottomRight);
export const ArrowDownIcon = iconFor(ArrowDown);
export const AutarkyIcon = iconFor(Autarky);
export const ArrowLeftIcon = iconFor(ArrowLeft);
export const ArrowRightIcon = iconFor(ArrowRight);
export const ArrowTopLeftIcon = iconFor(ArrowTopLeft);
export const ArrowUpIcon = iconFor(ArrowUp);
export const ArrowTopRightIcon = iconFor(AttowTopRight);
export const AttachmentIcon = iconFor(Attachment);
export const CalendarIcon = iconFor(Calendar);
export const CalenderAddIcon = iconFor(CalendarAdd);
export const FlowerViewIcon = iconFor(FlowerView);
export const CardsViewIcon = iconFor(CardsView);
export const CartCheckoutIcon = iconFor(CartCheckout);
export const ChargeFlashIcon = iconFor(ChargeFlash);
export const ChargeFullIcon = iconFor(ChargeFull);
export const ChargePlugIcon = iconFor(ChargePlug);
export const CheckIcon = iconFor(Check);
export const CheckboxIcon = iconFor(Checkbox);
export const CheckFilledIcon = iconFor(CheckFilled);
export const CheckmarkIcon = iconFor(Checkmark);
export const ChevronDownIcon = iconFor(ChevronDown);
export const ChevronLeftIcon = iconFor(ChevronLeft);
export const ChevronRightIcon = iconFor(ChevronRight);
export const ChevronUpIcon = iconFor(ChevronUp);
export const CircleCloseIcon = iconFor(CircleClose);
export const CloseFilledIcon = iconFor(CloseFilled);
export const CloseIcon = iconFor(Close);
export const CascadeIcon = iconFor(Cascade);
export const CloseSmallIcon = iconFor(CloseSmall);
export const CockpitIcon = iconFor(Cockpit);
export const DownloadIcon = iconFor(Download);
export const DuplicateIcon = iconFor(Duplicate);
export const EditIcon = iconFor(Edit);
export const Edit2Icon = iconFor(Edit2);
export const EkpDownloadIcon = iconFor(EkpDownload);
export const EmailIcon = iconFor(Email);
export const FileIcon = iconFor(File);
export const FileViewIcon = iconFor(FileView);
export const FavoriteIcon = iconFor(Favorite);
export const FavoriteFilledIcon = iconFor(FavoriteFilled);
export const PlusIcon = iconFor(Plus);
export const FileDownloadIcon = iconFor(FileDownload);
export const TrashIcon = iconFor(Trash);
export const FilterIcon = iconFor(Filter);
export const FilterHorIcon = iconFor(FilterHor);
export const PickupTruckIcon = iconFor(PickupTruck);
export const HelpIcon = iconFor(Help);
export const HomeIcon = iconFor(Home);
export const InfoFilledIcon = iconFor(InfoFilled);
export const InfoIcon = iconFor(Info);
export const InfocenterIcon = iconFor(Infocenter);
export const InfocenterLinkIcon = iconFor(InfocenterLink);
export const LabelIcon = iconFor(Label);
export const LabelFilledIcon = iconFor(LabelFilled);
export const LivedatenIcon = iconFor(Livedaten);
export const LinkIcon = iconFor(Link);
export const ListIcon = iconFor(List);
export const LockIcon = iconFor(Lock);
export const LogoutIcon = iconFor(Logout);
export const MapViewIcon = iconFor(MapView);
export const MegaphoneIcon = iconFor(MegaphoneSvg);
export const MenuIcon = iconFor(Menu);
export const MinimizeIcon = iconFor(Minimize);
export const MinusIcon = iconFor(Minus);
export const MinusCircleIcon = iconFor(MinusCircle);
export const XCircleIcon = iconFor(XCircle);
export const ModifyIcon = iconFor(Modify);
export const MonitorIcon = iconFor(Monitor);
export const MoreHorIcon = iconFor(MoreHor);
export const MoveIcon = iconFor(Move);
export const NavigateIcon = iconFor(Navigate);
export const NewsIcon = iconFor(News);
export const NoneMobileViewIcon = iconFor(NoneMobileView);
export const NotificationIcon = iconFor(Notification);
export const OfferCustomizationView = iconFor(OfferCustomization);
export const OpenInNewIcon = iconFor(OpenInNew);
export const PeakShavingIcon = iconFor(PeakShaving);
export const PlayFilledIcon = iconFor(PlayFilled);
export const PhoneIcon = iconFor(Phone);
export const QRCodeIcon = iconFor(QrCode);
export const RadioButtonOffIcon = iconFor(RadioButtonOff);
export const RadioButtonOnIcon = iconFor(RadioButtonOn);
export const RadioOffIcon = iconFor(RadioOff);
export const RadioOnIcon = iconFor(RadioOn);
export const RatioIcon = iconFor(Ratio);
export const ReclamationIcon = iconFor(Reclamation);
export const RefreshIcon = iconFor(Refresh);
export const ReloadIcon = iconFor(Reload);
export const RolloutIcon = iconFor(Rollout);
export const RouteplannerIcon = iconFor(Routeplanner);
export const SchnelleinstiegIcon = iconFor(Schnelleinstieg);
export const SearchIcon = iconFor(Search);
export const ShopIcon = iconFor(Shop);
export const SkipIcon = iconFor(Skip);
export const StarIcon = iconFor(Star);
export const StarActiveIcon = iconFor(StarActive);
export const StatusInactiveIcon = iconFor(StatusInactive);
export const SunnyIcon = iconFor(Sunny);
export const TurnOffIcon = iconFor(TurnOff);
export const UserIcon = iconFor(User);
export const UserRemoveIcon = iconFor(UserRemove);
export const UserListIcon = iconFor(UserList);
export const WaermepumpensteuerungIcon = iconFor(Waermepumpensteuerung);
export const WallboxIcon = iconFor(Wallbox);
export const WarningHardFilledIcon = iconFor(WarningHardFilled);
export const WarningFilledIcon = iconFor(WarningFilled);
export const WarningHardIcon = iconFor(WarningHard);
export const WiFiIcon = iconFor(WiFi);
export const WiFiOffIcon = iconFor(WiFiOff);
export const ZaehlerstandInputIcon = iconFor(ZaehlerstandInput);
export const VisibilityOffIcon = iconFor(VisibilityOff);
export const VisibilityOnIcon = iconFor(VisibilityOn);
export const InternetIcon = iconFor(Internet);
export const UploadIcon = iconFor(Upload);

/** @deprecated use the CloseIcon instead. */
export const ClearIcon = CloseIcon;
/** @deprecated use the CloseSmallIcon instead. */
export const ClearIconSmall = CloseSmallIcon;
/** @deprecated use the SearchIcon instead. */
export const LoupeIcon = SearchIcon;
/** @deprecated use the WarningHardIcon instead. */
export const InputErrorIcon = WarningHardIcon;
/** @deprecated use the MegaphoneIcon instead. */
export const Megaphone = MegaphoneIcon;
/** @deprecated use the MoreHorIcon instead. */
export const MoreIcon = MoreHorIcon;
/** @deprecated use the CloseSmallIcon instead. */
export const UnionIcon = CloseSmallIcon;
/** @deprecated use the CalendarIcon instead. */
export const UnionSmallIcon = CalendarIcon;
/** @deprecated use the WiFiOffIcon instead. */
export const WifiOffIcon = WiFiOffIcon;
/** @deprecated use the WiFiIcon instead. */
export const WifiOnIcon = WiFiIcon;

export { ElectricityIcon } from "./ElectricityIcon";
export { Home1Icon } from "./Home1Icon";
export { StatusActiveIcon } from "./StatusActiveIcon";
